import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProjectPackageSummaryVM } from "../../../api/generated/models";
import { PackageSummary } from "../../../api/models";

export interface IPackageSelectorState {
  isPackageSelectorModalOpen: boolean;
  selectedPackage: PackageSummary | null;
}

const initialState: IPackageSelectorState = {
  isPackageSelectorModalOpen: false,
  selectedPackage: null,
};

const packageSelectorSlice = createSlice({
  name: "packageSelector",
  initialState,
  reducers: {
    setIsPackageSelectorModalOpen(state, action: PayloadAction<boolean>) {
      state.isPackageSelectorModalOpen = action.payload;
    },
    setSelectedPackage(state, action: PayloadAction<ProjectPackageSummaryVM>) {
      state.selectedPackage = action.payload;
    },
    clearSelectedPackage(state) {
      state.selectedPackage = null;
    },
  },
});

export const {
  setIsPackageSelectorModalOpen,
  setSelectedPackage,
  clearSelectedPackage,
} = packageSelectorSlice.actions;

export default packageSelectorSlice.reducer;
